let inventoryRouteMapper = {
    'org' : 'org',
    'vdc': 'vdc',
    'vApp': 'vapp',
    'vm': 'vm',
    'directConnects': 'networks/directconnects',
    'directConnect': 'networks/directconnect',
    'orgVdcNetworks': 'networks/vdcnetworks',
    'orgVdcNetwork': 'networks/vdcnetwork',
    'transitNetworks': 'transitnetworks',
    'transitNetwork': 'transitnetwork',
    'gateways': 'networks/gateways',
    'gateway': 'networks/gateway',
    'networks': 'networks'
};
export default inventoryRouteMapper;



// WEBPACK FOOTER //
// ./src/app/components/inventory-main/inventory-route-mapper.ts